// Only resize compiled category photos. CMS replacements keep their own URL.
const files = import.meta.glob<string>('@assets/optimized_home/*-{240,320,480}.webp', {
  eager: true, query: '?url', import: 'default',
});
const variants = new Map<string, string>();
for (const [path, src] of Object.entries(files)) {
  if (!path.endsWith('-480.webp')) continue;
  if (![240, 320].every(width => files[path.replace('-480.webp', `-${width}.webp`)])) continue;
  variants.set(src, [240, 320, 480].map(width =>
    `${files[path.replace('-480.webp', `-${width}.webp`)] ?? src} ${width}w`).join(', '));
}
export function homeThumbnail(src: string, sizes: string) {
  return { src, srcSet: variants.get(src), sizes: variants.has(src) ? sizes : undefined };
}
